/**
 * Place des Arts — extras du sidecart (maître Figma 1979:145081) :
 *   « Partager panier » → permalink Shopify (/cart/{variant}:{qty},…) via navigator.share
 *   (mobile) ou copie presse-papiers (desktop).
 *
 * Le carrousel « Recommandation » du drawer VIDE est rendu en Liquid (SSR, collection
 * nouveautés) dans header-actions.liquid — plus aucun fetch S&D ici (refonte 2026-07-03).
 * Le cœur favori de la ligne est pris en charge par pda-wishlist.js.
 */
(() => {
  if (window.__pdaCartExtras) return;
  window.__pdaCartExtras = true;

  function flashShared() {
    document.querySelectorAll('[data-pda-cart-share]').forEach((b) => {
      if (b.dataset.busy) return;
      b.dataset.busy = '1';
      const label = b.querySelector('[data-pda-cart-share-label]') || b;
      const prev = label.textContent;
      label.textContent = 'Lien copié ✓';
      setTimeout(() => { label.textContent = prev; delete b.dataset.busy; }, 1600);
    });
  }
  async function shareCart() {
    let url = location.origin + '/cart';
    try {
      const cart = await fetch('/cart.js').then((r) => r.json());
      if (cart.items && cart.items.length) {
        url = location.origin + '/cart/' + cart.items.map((i) => `${i.variant_id}:${i.quantity}`).join(',');
      }
    } catch (e) { /* permalink panier courant en repli */ }
    if (navigator.share) {
      navigator.share({ title: document.title, url }).catch(() => {});
    } else if (navigator.clipboard) {
      navigator.clipboard.writeText(url).then(flashShared, () => {});
    }
  }
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-pda-cart-share]');
    if (b) { e.preventDefault(); shareCart(); }
  });
})();
